import { Button, Space, Tooltip } from 'antd'
import {
  EditFilenameModalState,
  UseEditFilenameModal,
} from '../hooks/useEditFilenameModal/types'
import { useProjectCustomFieldsContext } from 'components/CustomFields/ProjectCustomFieldsContext'
import { CustomFieldDataType, CustomListItemStyle, Report } from 'shared'

export function CompatibleTemplateItems<T extends EditFilenameModalState>({
  state,
  setTemplateItems,
  isDisabled,
}: UseEditFilenameModal<T>) {
  const { customFields } = useProjectCustomFieldsContext()
  return (
    <Space wrap>
      <Tooltip key="custom" title="Add a text box for custom text">
        <Button
          onClick={() =>
            setTemplateItems((prev) =>
              Array.of(...prev, { type: 'custom', value: '' })
            )
          }
        >
          Custom Text
        </Button>
      </Tooltip>
      {(state?.compatibleTemplateItems ?? []).map((item) => {
        const disabled = isDisabled(item)
        const { id, name, help } = item
        return (
          <Tooltip
            key={id}
            title={disabled ? `Cannot select ${name} if unset` : help}
          >
            <Button
              disabled={disabled}
              onClick={() =>
                setTemplateItems((prev) =>
                  Array.of(...prev, { type: 'templateItem', value: id })
                )
              }
            >
              {name}
            </Button>
          </Tooltip>
        )
      })}
      {state?.id === Report.ConstructionAdminSubmittal.id &&
        customFields
          .filter(
            ({ dataTypeId, metadata }) =>
              dataTypeId === CustomFieldDataType.Number.id ||
              dataTypeId === CustomFieldDataType.Date.id ||
              (dataTypeId === CustomFieldDataType.List.id &&
                metadata.styleId === CustomListItemStyle.Single.id)
          )
          .map(({ name, description, id }) => (
            <Tooltip key={id} title={description}>
              <Button
                onClick={() =>
                  setTemplateItems((prev) =>
                    Array.of(...prev, { type: 'customField', value: id })
                  )
                }
              >
                {name}
              </Button>
            </Tooltip>
          ))}
    </Space>
  )
}

export default CompatibleTemplateItems
